import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#3f51b5'
    },
    secondary: {
      main: '#f50057'
    },
    success: {
      main: '#35a03a'
    },
    text: {
      white: '#FFF'
    }
  },
  components: {
    RaMenuItemLink: {
      styleOverrides: {
        root: {
          color: '#c51162',
          '&.active': {
            color: '#ff4081'
          }
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          '&:after': {
            borderBottom: '1px solid #fff'
          }
        },
        root: {
          '&:after': {
            borderBottom: '1px solid #fff'
          },
          '&.Mui-error': {
            borderBottom: '1px solid #fff'
          }
        }
      }
    },
    MuiAppBar: {
      defaultProps: {
        color: 'primary'
      }
    }
  },
  shape: {
    borderRadius: 4
  }
})

export default theme
